import PropTypes from "prop-types";
import * as React from "react";
import { useDispatch } from "../../globalState";
import { actionCreators } from "../../reducer";
import { refreshIdentity } from "../../services/auth";
import { useBlockEmailModal } from "../../services/emailModalContext";
import { Box, Link, Typography } from "../../themeV2";
import CreateAccountForm from "./CreateAccountForm";
import SignInFlow from "./SignInFlow";

const AGREEMENT_VERB = Object.freeze({
  login: "logging in",
  create: "signing up",
});

export default function AuthFlow({ mode, modeSwitch, pending, onSuccess }) {
  const dispatch = useDispatch();
  useBlockEmailModal();

  const signedIn = React.useCallback(
    (user) => {
      dispatch(actionCreators.createSetUser(user));
      refreshIdentity();
      onSuccess(user);
    },
    [dispatch, onSuccess],
  );

  return (
    <Box direction="column" gap={4}>
      {mode === "login" ? (
        <SignInFlow pending={pending} onSignedIn={signedIn} />
      ) : (
        <CreateAccountForm onAnswered={({ body }) => signedIn(body.data)} />
      )}

      {modeSwitch}

      <Typography variant="body-sm" color="variant">
        By {AGREEMENT_VERB[mode]} you agree to our{" "}
        <Link to="/policy">policies</Link>.
      </Typography>
    </Box>
  );
}

AuthFlow.propTypes = {
  mode: PropTypes.oneOf(["login", "create"]).isRequired,
  modeSwitch: PropTypes.node,
  pending: PropTypes.shape({
    methods: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  onSuccess: PropTypes.func.isRequired,
};
